import { GrowthDataSet } from '../../types/data-set.types';

// WHO Weight-for-age GIRLS
// Birth to 5 years (monthly measurements)
export const whoGirlsWeightMonthly: GrowthDataSet = {
  id: 'who-girls-weight-monthly',
  source: 'WHO',
  title: 'Weight-for-age',
  intervalType: 'month',
  gender: 'female',
  measurementType: 'weight',
  ageRange: { min: 0, max: 60 },
  displayUnit: 'kg',
  dataPoints: [
    {
      age: 0,
      m: 3.2322,
      s: 0.14171,
      percentiles: {
        p1: 2.3,
        p3: 2.4,
        p5: 2.5,
        p15: 2.8,
        p25: 2.9,
        p50: 3.2,
        p75: 3.6,
        p85: 3.7,
        p95: 4,
        p97: 4.2,
        p99: 4.4,
      },
    },
    {
      age: 1,
      m: 4.1873,
      s: 0.13724,
      percentiles: {
        p1: 3,
        p3: 3.2,
        p5: 3.3,
        p15: 3.6,
        p25: 3.8,
        p50: 4.2,
        p75: 4.6,
        p85: 4.8,
        p95: 5.2,
        p97: 5.4,
        p99: 5.7,
      },
    },
    {
      age: 2,
      m: 5.1282,
      s: 0.13,
      percentiles: {
        p1: 3.8,
        p3: 4,
        p5: 4.1,
        p15: 4.5,
        p25: 4.7,
        p50: 5.1,
        p75: 5.6,
        p85: 5.9,
        p95: 6.3,
        p97: 6.5,
        p99: 6.9,
      },
    },
    {
      age: 3,
      m: 5.8458,
      s: 0.12619,
      percentiles: {
        p1: 4.4,
        p3: 4.6,
        p5: 4.7,
        p15: 5.1,
        p25: 5.4,
        p50: 5.8,
        p75: 6.4,
        p85: 6.7,
        p95: 7.2,
        p97: 7.4,
        p99: 7.8,
      },
    },
    {
      age: 4,
      m: 6.4237,
      s: 0.12402,
      percentiles: {
        p1: 4.8,
        p3: 5.1,
        p5: 5.2,
        p15: 5.6,
        p25: 5.9,
        p50: 6.4,
        p75: 7,
        p85: 7.3,
        p95: 7.9,
        p97: 8.1,
        p99: 8.6,
      },
    },
    {
      age: 5,
      m: 6.8985,
      s: 0.12274,
      percentiles: {
        p1: 5.2,
        p3: 5.5,
        p5: 5.6,
        p15: 6.1,
        p25: 6.4,
        p50: 6.9,
        p75: 7.5,
        p85: 7.8,
        p95: 8.4,
        p97: 8.7,
        p99: 9.2,
      },
    },
    {
      age: 6,
      m: 7.297,
      s: 0.12204,
      percentiles: {
        p1: 5.5,
        p3: 5.8,
        p5: 6,
        p15: 6.4,
        p25: 6.7,
        p50: 7.3,
        p75: 7.9,
        p85: 8.3,
        p95: 8.9,
        p97: 9.2,
        p99: 9.7,
      },
    },
    {
      age: 7,
      m: 7.6422,
      s: 0.12178,
      percentiles: {
        p1: 5.8,
        p3: 6.1,
        p5: 6.3,
        p15: 6.7,
        p25: 7,
        p50: 7.6,
        p75: 8.3,
        p85: 8.7,
        p95: 9.4,
        p97: 9.6,
        p99: 10.2,
      },
    },
    {
      age: 8,
      m: 7.9487,
      s: 0.12181,
      percentiles: {
        p1: 6,
        p3: 6.3,
        p5: 6.5,
        p15: 7,
        p25: 7.3,
        p50: 7.9,
        p75: 8.6,
        p85: 9,
        p95: 9.7,
        p97: 10,
        p99: 10.6,
      },
    },
    {
      age: 9,
      m: 8.2254,
      s: 0.12199,
      percentiles: {
        p1: 6.2,
        p3: 6.6,
        p5: 6.8,
        p15: 7.3,
        p25: 7.6,
        p50: 8.2,
        p75: 8.9,
        p85: 9.3,
        p95: 10.1,
        p97: 10.4,
        p99: 11,
      },
    },
    {
      age: 10,
      m: 8.48,
      s: 0.12223,
      percentiles: {
        p1: 6.4,
        p3: 6.8,
        p5: 7,
        p15: 7.5,
        p25: 7.8,
        p50: 8.5,
        p75: 9.2,
        p85: 9.6,
        p95: 10.4,
        p97: 10.7,
        p99: 11.3,
      },
    },
    {
      age: 11,
      m: 8.7192,
      s: 0.12247,
      percentiles: {
        p1: 6.6,
        p3: 7,
        p5: 7.2,
        p15: 7.7,
        p25: 8,
        p50: 8.7,
        p75: 9.5,
        p85: 9.9,
        p95: 10.7,
        p97: 11,
        p99: 11.7,
      },
    },
    {
      age: 12,
      m: 8.9481,
      s: 0.12268,
      percentiles: {
        p1: 6.8,
        p3: 7.1,
        p5: 7.3,
        p15: 7.9,
        p25: 8.2,
        p50: 8.9,
        p75: 9.7,
        p85: 10.2,
        p95: 11,
        p97: 11.3,
        p99: 12,
      },
    },
    {
      age: 13,
      m: 9.1699,
      s: 0.12283,
      percentiles: {
        p1: 6.9,
        p3: 7.3,
        p5: 7.5,
        p15: 8.1,
        p25: 8.4,
        p50: 9.2,
        p75: 10,
        p85: 10.4,
        p95: 11.3,
        p97: 11.6,
        p99: 12.3,
      },
    },
    {
      age: 14,
      m: 9.387,
      s: 0.12294,
      percentiles: {
        p1: 7.1,
        p3: 7.5,
        p5: 7.7,
        p15: 8.3,
        p25: 8.6,
        p50: 9.4,
        p75: 10.2,
        p85: 10.7,
        p95: 11.5,
        p97: 11.9,
        p99: 12.6,
      },
    },
    {
      age: 15,
      m: 9.6008,
      s: 0.12299,
      percentiles: {
        p1: 7.3,
        p3: 7.7,
        p5: 7.9,
        p15: 8.5,
        p25: 8.8,
        p50: 9.6,
        p75: 10.4,
        p85: 10.9,
        p95: 11.8,
        p97: 12.2,
        p99: 12.9,
      },
    },
    {
      age: 16,
      m: 9.8124,
      s: 0.12303,
      percentiles: {
        p1: 7.4,
        p3: 7.8,
        p5: 8.1,
        p15: 8.7,
        p25: 9,
        p50: 9.8,
        p75: 10.7,
        p85: 11.2,
        p95: 12.1,
        p97: 12.5,
        p99: 13.2,
      },
    },
    {
      age: 17,
      m: 10.0226,
      s: 0.12306,
      percentiles: {
        p1: 7.6,
        p3: 8,
        p5: 8.2,
        p15: 8.8,
        p25: 9.2,
        p50: 10,
        p75: 10.9,
        p85: 11.4,
        p95: 12.3,
        p97: 12.7,
        p99: 13.5,
      },
    },
    {
      age: 18,
      m: 10.2315,
      s: 0.12309,
      percentiles: {
        p1: 7.8,
        p3: 8.2,
        p5: 8.4,
        p15: 9,
        p25: 9.4,
        p50: 10.2,
        p75: 11.1,
        p85: 11.6,
        p95: 12.6,
        p97: 13,
        p99: 13.8,
      },
    },
    {
      age: 19,
      m: 10.4393,
      s: 0.12315,
      percentiles: {
        p1: 7.9,
        p3: 8.3,
        p5: 8.6,
        p15: 9.2,
        p25: 9.6,
        p50: 10.4,
        p75: 11.4,
        p85: 11.9,
        p95: 12.9,
        p97: 13.3,
        p99: 14.1,
      },
    },
    {
      age: 20,
      m: 10.6464,
      s: 0.12323,
      percentiles: {
        p1: 8.1,
        p3: 8.5,
        p5: 8.7,
        p15: 9.4,
        p25: 9.8,
        p50: 10.6,
        p75: 11.6,
        p85: 12.1,
        p95: 13.1,
        p97: 13.5,
        p99: 14.4,
      },
    },
    {
      age: 21,
      m: 10.8534,
      s: 0.12335,
      percentiles: {
        p1: 8.2,
        p3: 8.7,
        p5: 8.9,
        p15: 9.6,
        p25: 10,
        p50: 10.9,
        p75: 11.8,
        p85: 12.4,
        p95: 13.4,
        p97: 13.8,
        p99: 14.6,
      },
    },
    {
      age: 22,
      m: 11.0608,
      s: 0.1235,
      percentiles: {
        p1: 8.4,
        p3: 8.8,
        p5: 9.1,
        p15: 9.8,
        p25: 10.2,
        p50: 11.1,
        p75: 12,
        p85: 12.6,
        p95: 13.6,
        p97: 14.1,
        p99: 14.9,
      },
    },
    {
      age: 23,
      m: 11.2688,
      s: 0.12369,
      percentiles: {
        p1: 8.5,
        p3: 9,
        p5: 9.2,
        p15: 9.9,
        p25: 10.4,
        p50: 11.3,
        p75: 12.3,
        p85: 12.8,
        p95: 13.9,
        p97: 14.3,
        p99: 15.2,
      },
    },
    {
      age: 24,
      m: 11.4775,
      s: 0.1239,
      percentiles: {
        p1: 8.7,
        p3: 9.2,
        p5: 9.4,
        p15: 10.1,
        p25: 10.6,
        p50: 11.5,
        p75: 12.5,
        p85: 13.1,
        p95: 14.2,
        p97: 14.6,
        p99: 15.5,
      },
    },
    {
      age: 25,
      m: 11.6864,
      s: 0.12414,
      percentiles: {
        p1: 8.9,
        p3: 9.3,
        p5: 9.6,
        p15: 10.3,
        p25: 10.8,
        p50: 11.7,
        p75: 12.7,
        p85: 13.3,
        p95: 14.4,
        p97: 14.9,
        p99: 15.8,
      },
    },
    {
      age: 26,
      m: 11.8947,
      s: 0.12441,
      percentiles: {
        p1: 9,
        p3: 9.5,
        p5: 9.8,
        p15: 10.5,
        p25: 10.9,
        p50: 11.9,
        p75: 12.9,
        p85: 13.6,
        p95: 14.7,
        p97: 15.2,
        p99: 16.1,
      },
    },
    {
      age: 27,
      m: 12.1015,
      s: 0.12472,
      percentiles: {
        p1: 9.2,
        p3: 9.6,
        p5: 9.9,
        p15: 10.7,
        p25: 11.1,
        p50: 12.1,
        p75: 13.2,
        p85: 13.8,
        p95: 15,
        p97: 15.4,
        p99: 16.4,
      },
    },
    {
      age: 28,
      m: 12.3059,
      s: 0.12506,
      percentiles: {
        p1: 9.3,
        p3: 9.8,
        p5: 10.1,
        p15: 10.8,
        p25: 11.3,
        p50: 12.3,
        p75: 13.4,
        p85: 14,
        p95: 15.2,
        p97: 15.7,
        p99: 16.7,
      },
    },
    {
      age: 29,
      m: 12.5073,
      s: 0.12545,
      percentiles: {
        p1: 9.5,
        p3: 10,
        p5: 10.2,
        p15: 11,
        p25: 11.5,
        p50: 12.5,
        p75: 13.6,
        p85: 14.3,
        p95: 15.5,
        p97: 16,
        p99: 17,
      },
    },
    {
      age: 30,
      m: 12.7055,
      s: 0.12587,
      percentiles: {
        p1: 9.6,
        p3: 10.1,
        p5: 10.4,
        p15: 11.2,
        p25: 11.7,
        p50: 12.7,
        p75: 13.8,
        p85: 14.5,
        p95: 15.7,
        p97: 16.2,
        p99: 17.3,
      },
    },
    {
      age: 31,
      m: 12.9006,
      s: 0.12633,
      percentiles: {
        p1: 9.7,
        p3: 10.3,
        p5: 10.5,
        p15: 11.3,
        p25: 11.9,
        p50: 12.9,
        p75: 14.1,
        p85: 14.7,
        p95: 16,
        p97: 16.5,
        p99: 17.6,
      },
    },
    {
      age: 32,
      m: 13.093,
      s: 0.12683,
      percentiles: {
        p1: 9.9,
        p3: 10.4,
        p5: 10.7,
        p15: 11.5,
        p25: 12,
        p50: 13.1,
        p75: 14.3,
        p85: 15,
        p95: 16.2,
        p97: 16.8,
        p99: 17.8,
      },
    },
    {
      age: 33,
      m: 13.2837,
      s: 0.12737,
      percentiles: {
        p1: 10,
        p3: 10.5,
        p5: 10.8,
        p15: 11.7,
        p25: 12.2,
        p50: 13.3,
        p75: 14.5,
        p85: 15.2,
        p95: 16.5,
        p97: 17,
        p99: 18.1,
      },
    },
    {
      age: 34,
      m: 13.4731,
      s: 0.12794,
      percentiles: {
        p1: 10.1,
        p3: 10.7,
        p5: 11,
        p15: 11.8,
        p25: 12.4,
        p50: 13.5,
        p75: 14.7,
        p85: 15.4,
        p95: 16.8,
        p97: 17.3,
        p99: 18.4,
      },
    },
    {
      age: 35,
      m: 13.6618,
      s: 0.12855,
      percentiles: {
        p1: 10.3,
        p3: 10.8,
        p5: 11.1,
        p15: 12,
        p25: 12.5,
        p50: 13.7,
        p75: 14.9,
        p85: 15.7,
        p95: 17,
        p97: 17.6,
        p99: 18.7,
      },
    },
    {
      age: 36,
      m: 13.8503,
      s: 0.12919,
      percentiles: {
        p1: 10.4,
        p3: 11,
        p5: 11.3,
        p15: 12.1,
        p25: 12.7,
        p50: 13.9,
        p75: 15.1,
        p85: 15.9,
        p95: 17.3,
        p97: 17.8,
        p99: 19,
      },
    },
    {
      age: 37,
      m: 14.0385,
      s: 0.12988,
      percentiles: {
        p1: 10.5,
        p3: 11.1,
        p5: 11.4,
        p15: 12.3,
        p25: 12.9,
        p50: 14,
        p75: 15.3,
        p85: 16.1,
        p95: 17.5,
        p97: 18.1,
        p99: 19.3,
      },
    },
    {
      age: 38,
      m: 14.2265,
      s: 0.13059,
      percentiles: {
        p1: 10.6,
        p3: 11.2,
        p5: 11.6,
        p15: 12.5,
        p25: 13,
        p50: 14.2,
        p75: 15.6,
        p85: 16.3,
        p95: 17.8,
        p97: 18.4,
        p99: 19.6,
      },
    },
    {
      age: 39,
      m: 14.414,
      s: 0.13135,
      percentiles: {
        p1: 10.8,
        p3: 11.4,
        p5: 11.7,
        p15: 12.6,
        p25: 13.2,
        p50: 14.4,
        p75: 15.8,
        p85: 16.6,
        p95: 18,
        p97: 18.6,
        p99: 19.9,
      },
    },
    {
      age: 40,
      m: 14.601,
      s: 0.13213,
      percentiles: {
        p1: 10.9,
        p3: 11.5,
        p5: 11.8,
        p15: 12.8,
        p25: 13.4,
        p50: 14.6,
        p75: 16,
        p85: 16.8,
        p95: 18.3,
        p97: 18.9,
        p99: 20.2,
      },
    },
    {
      age: 41,
      m: 14.7873,
      s: 0.13293,
      percentiles: {
        p1: 11,
        p3: 11.6,
        p5: 12,
        p15: 12.9,
        p25: 13.5,
        p50: 14.8,
        p75: 16.2,
        p85: 17,
        p95: 18.6,
        p97: 19.2,
        p99: 20.5,
      },
    },
    {
      age: 42,
      m: 14.9727,
      s: 0.13376,
      percentiles: {
        p1: 11.1,
        p3: 11.8,
        p5: 12.1,
        p15: 13.1,
        p25: 13.7,
        p50: 15,
        p75: 16.4,
        p85: 17.3,
        p95: 18.8,
        p97: 19.5,
        p99: 20.8,
      },
    },
    {
      age: 43,
      m: 15.1573,
      s: 0.1346,
      percentiles: {
        p1: 11.3,
        p3: 11.9,
        p5: 12.2,
        p15: 13.2,
        p25: 13.9,
        p50: 15.2,
        p75: 16.6,
        p85: 17.5,
        p95: 19.1,
        p97: 19.7,
        p99: 21.1,
      },
    },
    {
      age: 44,
      m: 15.341,
      s: 0.13545,
      percentiles: {
        p1: 11.4,
        p3: 12,
        p5: 12.4,
        p15: 13.4,
        p25: 14,
        p50: 15.3,
        p75: 16.8,
        p85: 17.7,
        p95: 19.3,
        p97: 20,
        p99: 21.4,
      },
    },
    {
      age: 45,
      m: 15.524,
      s: 0.1363,
      percentiles: {
        p1: 11.5,
        p3: 12.1,
        p5: 12.5,
        p15: 13.5,
        p25: 14.2,
        p50: 15.5,
        p75: 17,
        p85: 17.9,
        p95: 19.6,
        p97: 20.3,
        p99: 21.7,
      },
    },
    {
      age: 46,
      m: 15.7064,
      s: 0.13716,
      percentiles: {
        p1: 11.6,
        p3: 12.3,
        p5: 12.6,
        p15: 13.7,
        p25: 14.3,
        p50: 15.7,
        p75: 17.3,
        p85: 18.2,
        p95: 19.9,
        p97: 20.6,
        p99: 22,
      },
    },
    {
      age: 47,
      m: 15.8882,
      s: 0.138,
      percentiles: {
        p1: 11.7,
        p3: 12.4,
        p5: 12.8,
        p15: 13.8,
        p25: 14.5,
        p50: 15.9,
        p75: 17.5,
        p85: 18.4,
        p95: 20.1,
        p97: 20.8,
        p99: 22.3,
      },
    },
    {
      age: 48,
      m: 16.0697,
      s: 0.13884,
      percentiles: {
        p1: 11.8,
        p3: 12.5,
        p5: 12.9,
        p15: 14,
        p25: 14.7,
        p50: 16.1,
        p75: 17.7,
        p85: 18.6,
        p95: 20.4,
        p97: 21.1,
        p99: 22.6,
      },
    },
    {
      age: 49,
      m: 16.2511,
      s: 0.13968,
      percentiles: {
        p1: 11.9,
        p3: 12.6,
        p5: 13,
        p15: 14.1,
        p25: 14.8,
        p50: 16.3,
        p75: 17.9,
        p85: 18.9,
        p95: 20.6,
        p97: 21.4,
        p99: 22.9,
      },
    },
    {
      age: 50,
      m: 16.4322,
      s: 0.14051,
      percentiles: {
        p1: 12.1,
        p3: 12.8,
        p5: 13.2,
        p15: 14.3,
        p25: 15,
        p50: 16.4,
        p75: 18.1,
        p85: 19.1,
        p95: 20.9,
        p97: 21.7,
        p99: 23.2,
      },
    },
    {
      age: 51,
      m: 16.6133,
      s: 0.14132,
      percentiles: {
        p1: 12.2,
        p3: 12.9,
        p5: 13.3,
        p15: 14.4,
        p25: 15.1,
        p50: 16.6,
        p75: 18.3,
        p85: 19.3,
        p95: 21.2,
        p97: 22,
        p99: 23.5,
      },
    },
    {
      age: 52,
      m: 16.7942,
      s: 0.14213,
      percentiles: {
        p1: 12.3,
        p3: 13,
        p5: 13.4,
        p15: 14.5,
        p25: 15.3,
        p50: 16.8,
        p75: 18.5,
        p85: 19.5,
        p95: 21.4,
        p97: 22.2,
        p99: 23.9,
      },
    },
    {
      age: 53,
      m: 16.9748,
      s: 0.14293,
      percentiles: {
        p1: 12.4,
        p3: 13.1,
        p5: 13.5,
        p15: 14.7,
        p25: 15.4,
        p50: 17,
        p75: 18.7,
        p85: 19.8,
        p95: 21.7,
        p97: 22.5,
        p99: 24.2,
      },
    },
    {
      age: 54,
      m: 17.1551,
      s: 0.14371,
      percentiles: {
        p1: 12.5,
        p3: 13.2,
        p5: 13.7,
        p15: 14.8,
        p25: 15.6,
        p50: 17.2,
        p75: 18.9,
        p85: 20,
        p95: 22,
        p97: 22.8,
        p99: 24.5,
      },
    },
    {
      age: 55,
      m: 17.3347,
      s: 0.14448,
      percentiles: {
        p1: 12.6,
        p3: 13.4,
        p5: 13.8,
        p15: 15,
        p25: 15.8,
        p50: 17.3,
        p75: 19.1,
        p85: 20.2,
        p95: 22.2,
        p97: 23.1,
        p99: 24.8,
      },
    },
    {
      age: 56,
      m: 17.5136,
      s: 0.14525,
      percentiles: {
        p1: 12.7,
        p3: 13.5,
        p5: 13.9,
        p15: 15.1,
        p25: 15.9,
        p50: 17.5,
        p75: 19.3,
        p85: 20.4,
        p95: 22.5,
        p97: 23.3,
        p99: 25.1,
      },
    },
    {
      age: 57,
      m: 17.6916,
      s: 0.146,
      percentiles: {
        p1: 12.8,
        p3: 13.6,
        p5: 14,
        p15: 15.3,
        p25: 16.1,
        p50: 17.7,
        p75: 19.6,
        p85: 20.7,
        p95: 22.7,
        p97: 23.6,
        p99: 25.4,
      },
    },
    {
      age: 58,
      m: 17.8686,
      s: 0.14675,
      percentiles: {
        p1: 12.9,
        p3: 13.7,
        p5: 14.2,
        p15: 15.4,
        p25: 16.2,
        p50: 17.9,
        p75: 19.8,
        p85: 20.9,
        p95: 23,
        p97: 23.9,
        p99: 25.7,
      },
    },
    {
      age: 59,
      m: 18.0445,
      s: 0.14748,
      percentiles: {
        p1: 13.1,
        p3: 13.8,
        p5: 14.3,
        p15: 15.5,
        p25: 16.4,
        p50: 18,
        p75: 20,
        p85: 21.1,
        p95: 23.3,
        p97: 24.2,
        p99: 26,
      },
    },
    {
      age: 60,
      m: 18.2193,
      s: 0.14821,
      percentiles: {
        p1: 13.2,
        p3: 14,
        p5: 14.4,
        p15: 15.7,
        p25: 16.5,
        p50: 18.2,
        p75: 20.2,
        p85: 21.3,
        p95: 23.5,
        p97: 24.4,
        p99: 26.3,
      },
    },
  ],
};
